import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { Heading } from '../heading/heading';
const b = bemClassBuilder('v-detail');
/**
 * Represents some content with an optional heading.
 *
 * Will not render anything if the content is undefined or empty.
 */
export const Detail = observer(props => {
    const { className, headingLevel, heading, content } = props;
    if (!content || content.length === 0)
        return null;
    return (_jsxs("div", Object.assign({ className: b.block(undefined, className) }, { children: [heading && (_jsx(Heading, Object.assign({ className: b.element('heading'), level: headingLevel }, { children: heading }))), _jsx("div", Object.assign({ className: b.element('content') }, { children: content }))] })));
});
Detail.displayName = 'Detail';
export const DetailSkeleton = ({ className }) => (_jsxs("div", Object.assign({ className: b.block({ skeleton: true }, className) }, { children: [_jsx("div", { className: b.element('heading', { skeleton: true }) }), _jsx("div", { className: b.element('content', { skeleton: true }) })] })));
DetailSkeleton.displayName = 'DetailSkeleton';
